import { ReactComponent as CloseSvg } from 'assets/images/generate-certificate/close.svg';
import { DropdownIndicator } from 'components/universal/addMultipleUser';
import { Button } from 'components/universal/button';
import { Input } from 'components/universal/input';
import { AsyncPaginate } from 'react-select-async-paginate';
import { Controller } from 'react-hook-form';
import cls from './firstLoginModal.module.scss';
import { useFirstLoginModal } from './useFirstLoginModal';
import { Checkbox } from '../checkbox';
import { Accordion } from '../accordion';
import { RegistrationClause } from 'views/registration/RegistrationClause';

export const FirstLoginModal = () => {
    const {
        t,
        isOpen,
        hasName,
        requiredFields,
        isDateTriggered,
        register,
        handleSubmit,
        errors,
        onSubmit,
        loadWorkplaceOptions,
        handleWorkplaceChange,
        selectedWorkplace,
        selectedDepartment,
        needsDepartment,
        loadDepartmentOptions,
        handleDepartmentChange,
        control,
        showWorkplaceSelect,
        currentWorkplaceId
    } = useFirstLoginModal();

    if (!isOpen) return null;

    const onlyDepartment = needsDepartment && !isDateTriggered && !requiredFields.includes('first_name') && !requiredFields.includes('last_name') && !showWorkplaceSelect;

    return (
        <div className={cls.overlay}>
            <div className={cls.wrapper}>
                <div className={cls.content}>
                    <h2 className={cls.title}>
                        {onlyDepartment
                            ? t('registration.firstLoginModal.titleDepartment')
                            : hasName
                            ? t('registration.firstLoginModal.title')
                            : t('registration.firstLoginModal.titleSecond')}
                    </h2>
                    {!hasName && (
                        <p className={cls.description}>
                            {t('registration.firstLoginModal.description')}
                        </p>
                    )}
                    <form className={cls.form} onSubmit={handleSubmit(onSubmit)}>
                        {requiredFields.includes('first_name') && (
                                <Input
                                    className={cls.field}
                                    register={register}
                                    id="first_name"
                                    name="first_name"
                                    label={t('registration.firstNameRequire')}
                                    error={t(errors.first_name?.message)}
                                    maxLength={255}
                                />
                        )}
                        {requiredFields.includes('last_name') && (
                                <Input
                                    className={cls.field}
                                    register={register}
                                    id="last_name"
                                    name="last_name"
                                    label={t('registration.lastNameRequire')}
                                    error={t(errors.last_name?.message)}
                                    maxLength={255}
                                />
                        )}
                        {showWorkplaceSelect && (
                        <div className={`${cls.selectWrapper} ${cls.fieldFull}`}>
                            {!hasName && (
                                <p className={cls.headline2}>{t('registration.firstLoginModal.confirmWorkplace')}</p>
                            )}
                            <label className={cls.label}>
                                {t('registration.firstLoginModal.workplace')}
                            </label>
                            <Controller
                                name="workplace_id"
                                control={control}
                                render={({ field }) => (
                                    <AsyncPaginate
                                        className={errors.workplace_id ? 'error react-select-container' : 'react-select-container'}
                                        classNamePrefix="react-select"
                                        components={{ DropdownIndicator }}
                                        placeholder=""
                                        value={selectedWorkplace}
                                        loadOptions={loadWorkplaceOptions}
                                        additional={{ page: 1 }}
                                        onChange={handleWorkplaceChange}
                                        noOptionsMessage={() => t('registration.noOptions')}
                                        debounceTimeout={300}
                                    />
                                )}
                            />
                            {errors.workplace_id && (
                                <span className={cls.error}>{t(errors.workplace_id.message)}</span>
                            )}
                        </div>
                        )}
                        {hasName && (
                            <>
                                <input type="hidden" {...register('first_name')} />
                                <input type="hidden" {...register('last_name')} />
                            </>
                        )}
                        <input type="hidden" {...register('employee_position_name')} />
                        {needsDepartment && (
                            <div className={cls.selectWrapper}>
                                <label className={cls.label}>
                                    {t('registration.firstLoginModal.department')}
                                </label>
                                <Controller
                                    name="department_id"
                                    control={control}
                                    render={({ field }) => (
                                        <AsyncPaginate
                                            key={selectedWorkplace?.value?.id ?? 'no-workplace'}
                                            className={errors.department_id ? 'error react-select-container' : 'react-select-container'}
                                            classNamePrefix="react-select"
                                            components={{ DropdownIndicator }}
                                            placeholder=""
                                            value={selectedDepartment}
                                            loadOptions={loadDepartmentOptions}
                                            additional={{ page: 1 }}
                                            onChange={(selected) => handleDepartmentChange(selected as any, field.onChange)}
                                            noOptionsMessage={() => t('registration.noDepartments')}
                                            debounceTimeout={300}
                                        />
                                    )}
                                />
                                {errors.department_id && (
                                    <span className={cls.error}>{t(errors.department_id.message).replace('department id', t('registration.firstLoginModal.department').toLowerCase())}</span>
                                )}
                            </div>
                        )}
                        {!onlyDepartment && (
                        <Checkbox
                            className={cls.checkbox}
                            register={register}
                            id="agreement"
                            name="agreement"
                            label={t('registration.consent')}
                            error={t(errors.agreement?.message)}
                        />
                        )}
                        {!onlyDepartment && (
                        <div className={cls.accordion}>
                            <Accordion
                                label={t('registration.infoClause')}
                                arrow
                                height={100}
                            >
                                <RegistrationClause />
                            </Accordion>
                        </div>
                        )}
                        <div className={cls.buttonWrapper}>
                            <Button type="submit" className={cls.button}>
                                {t('registration.firstLoginModal.button')}
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};
